import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';
import { BodyText, TextLinkifyTags } from '@sg/garnish';

export const LoyaltyTerms = (props: LoyaltyTermsProps) => {
  const { termsAndConditionsUrl } = props;

  const { formatMessage } = useIntl();
  const links = useMemo(
    () => [
      {
        tag: 'terms',
        description: formatMessage(messages.termsTag),
        href: termsAndConditionsUrl,
        underline: true,
      },
    ],
    [termsAndConditionsUrl, formatMessage],
  );

  return (
    <BodyText style={styles.label} sizeMatch={['12', '22']}>
      <TextLinkifyTags
        palette="sweet-corn"
        sizeMatch={['12', '22']}
        links={links}
      >
        {formatMessage(messages.terms, { terms: '{terms}' })}
      </TextLinkifyTags>
    </BodyText>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  termsTag: {
    defaultMessage: 'Terms',
    description: 'Loyalty Home | Footer | subtitle',
  },
  terms: {
    defaultMessage: '*See full {terms} for more details',
    description: 'Loyalty Home | Footer | subtitle',
  },
});

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  label: {
    color: theme.colors.CREAM,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type LoyaltyTermsProps = {
  termsAndConditionsUrl: string;
};
